// extracted by mini-css-extract-plugin
export default {"badge":"TierBadge_badge__-ca9G","tierA":"TierBadge_tierA__20htA","tierB":"TierBadge_tierB__EVNgT","tierC":"TierBadge_tierC__CRG+v","tierD":"TierBadge_tierD__nywiU"};